import "../CSS/ingresarCodigo.css";

import React, { useRef, useEffect, useState, Fragment } from "react";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { db } from "../FirebaseConfig/firebase";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { useNavigate, useParams, Link } from "react-router-dom";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import { addDoc, updateDoc } from "firebase/firestore";
import { collection } from "firebase/firestore";
import { QRCodeCanvas } from "qrcode.react";
import { useLocation } from "react-router-dom";
import logo from "../img/logo_cip.png";
import axios from "axios";

const MySwal = withReactContent(Swal);

function Entrada(props) {
  const navigate = useNavigate();
  const {
    salon,
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    fechaCompra,
    comidas,
    nroTicket,
    asientosString,
    handleConvert,
    tipoEvento,
	lugar
  } = props;

  const [datosCargados, setDatosCargados] = useState(true); // MOSTRAR BARRA DE CARGA
  const [shortUrl, setShortUrl] = useState("");

  const handleShortenUrl = async () => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
          window.location.href
        )}`
      );
      //console.log("link corto " + response.data.replace("https://", ""));
      setShortUrl(response.data.replace("https://", ""));
    } catch (error) {
      console.error("Error:", error);
    }
  };
  /*const handleShortenUrl = async () => {
    try {
      const response = await fetch(
        `https://api.shrtco.de/v2/shorten?url=${"http://www.edrups.com/eventoscip/#/eventos/UMJ49JmQ9YtcRRn6ORqh/registrarParticipante/Ve7zfv7DK96yk36Dgu7k"}`
      );
      const data = await response.json();
      console.log("link corto " + data.result.full_short_link);
		
      setShortUrl(data.result.full_short_link);
    } catch (e) {
      alert(e);
    }
  };*/
  /*const handleShortenUrl = () => {
    // Genera una clave única para la URL acortada
    const key = firebase.database().ref().push().key;

    // Guarda la URL larga en la base de datos de Firebase
    firebase.database().ref(`urls/${key}`).set({
      longUrl: longUrl
    });

    // Crea la URL corta utilizando el ID generado
    const shortUrl = `${window.location.origin}/${key}`;
    setShortUrl(shortUrl);
  };
*/
  const qrcode = (
    <QRCodeCanvas
      style={{ marginTop: "10px" }}
      id="qrCode"
      value={shortUrl}
      size={150}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );

  useEffect(() => {
    handleShortenUrl();
	console.log(tipoEvento)
  }, []);
  useEffect(() => {
    handleConvert();
  }, [shortUrl]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  const backgroundStyle = {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "#ecedef ",
    // Otros estilos opcionales
  };
  return (
    <div className="codigo" style={backgroundStyle}>
      <div className="codigo-root" style={{ padding: "0px" }}>
        <div className="codigo-padreIzquierda">
          <div className="codigo-hIzquierda">
            <h1 className="ts-fecha-compra">
              <span>{fechaCompra.split(",")[0]}</span>
              <br />
              {lugar == "Salon de eventos" ? (
                <span className="ts-numero-ticket">
                  Ticket Nro: {nroTicket}
                </span>
              ) : null}
            </h1>
          </div>
        </div>
        <div className="codigo-padreDerecha">
          <div className="codigo-hDerecha">
            <h1 style={{ margin: "10px", textAlign: "center" }}>{nombre}</h1>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {qrcode}
            </div>
            <div className="codigo-asientos">
              <h4>
                <span>
                  {asientos.split(",").length} Asiento(s)<br></br>{" "}
                  <pre style={{ fontFamily: "sans-serif", margin: "0px" }}>
                    {asientosString}
                  </pre>
                </span>
              </h4>
            </div>

            <form action="/" className="codigo-form">
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "0px" }}>
                {nombreParticipante}
              </a>
              <a style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}>
                Participante
              </a>
              {tipoEvento == "Pago (con comida)" ? (
                <div style={{ textAlign: "center" }} className="codigo-form">
                  <a
                    style={{
                      fontSize: "18px",
                      margin: "0",
                      paddingTop: "10px",
                    }}
                  >
                    {comidas}
                  </a>
				  
                  <a
                    style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}
                  >
                    Comidas
                  </a>{" "}
				  
                </div>
              ) : null}
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {salon}
              </a>
              <a style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}>
                Lugar
              </a>
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {fecha}
              </a>
              <a
                style={{
                  fontSize: "16px",
                  margin: "0",
                  paddingBottom: "20px",
                  color: "#af9e07",
                }}
              >
                Fecha y hora
              </a>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Entrada;
